module.exports = __webpack_public_path__ + "static/media/express.0fb30b49.svg";